<template>

  <div class="carousel-view">
    <transition-group name="fade" class="carousel">
      <div class="-centered-info" v-for="slide in slides" :key="slide.id">
        <h3 class="title">{{ slide.maintitle }}</h3>
        <img :src="slide.icon" class="icon">
        <p class="text">{{ slide.secondarytitle }}</p>
      </div>
    </transition-group>
    <button class="carousel-button prev" @click="previousSlide"><img src="/static/svg/icon_feather-chevron-left.svg"></button>
    <button class="carousel-button next" @click="nextSlide"><img src="/static/svg/icon_feather-chevron-right.svg"></button>
  </div>

</template>

<script>

export default {
  name: 'FundingCarousel',
  data () {
    return {
      slides: [
        {
          id: 1,
          maintitle: '1. No cobramos los intereses no devengados.',
          secondarytitle: 'Si prepagas tu crédito, te cobramos sólo los intereses hasta el día que pagas. En el resto de los créditos aplicamos la normativa vigente.',
          icon: '/static/svg/funding-slide1.svg'
        },
        {
          id: 2,
          maintitle: '2. Tú tienes el control.',
          secondarytitle: 'En Cumplo, tú defines la tasa, los montos y plazos asociados al crédito. Contarás con el apoyo de tu representante comercial en todo momento. Te recordamos que quienes te financian son inversionistas, para que elijas una tasa que les resulte atractiva y financien tu solicitud.',
          icon: '/static/svg/funding-slide2.svg'
        },
        {
          id: 3,
          maintitle: '3. Reduce tu tasa de interés.',
          secondarytitle: 'Mientras más créditos publiques a través de Cumplo, mayor confianza generarás a los inversionistas. Un buen comportamiento de pago se premia con la reducción de la tasa en tus siguientes solicitudes.',
          icon: '/static/svg/funding-slide3.svg'
        },
        {
          id: 4,
          maintitle: '4. No ganamos por mora.',
          secondarytitle: 'Los intereses adicionales generados por atrasos van directamente a los inversionistas. En Cumplo cobramos sólo por uso de plataforma, el cual depende del dinero solicitado y de los plazos de pago independientemente de la mora.',
          icon: '/static/svg/funding-slide4.svg'
        },
        {
          id: 5,
          maintitle: '5. Te ofrecemos financiamiento a una tasa justa.',
          secondarytitle: 'En Cumplo no ganamos ni perdemos con la variación de la tasa. La tasa la fijas tú y nuestros inversionistas financian tus créditos a cambio de rendimientos justos. Con esto, buscamos que tu PyME obtenga la tasa más baja posible dependiendo de sus características.',
          icon: '/static/svg/funding-slide5.svg'
        }
      ]
    }
  },
  methods: {
    nextSlide () {
      const first = this.slides.shift()
      this.slides = this.slides.concat(first)
    },
    previousSlide () {
      const last = this.slides.pop()
      this.slides = [last].concat(this.slides)
    }
  }
}

</script>

<style lang="scss" scoped>

.carousel-view {
  position: relative;
  padding: 6rem;
  background-color: $grey-100;

  .title {
    font-weight: 300;
  }

  .text {
    margin-top: 2rem;
  }
}

.carousel > :not(:first-child) {
  display: none;
}

.carousel-button {
  position: absolute;
  top: 36%;
  padding: 1rem .7rem;
  height: auto;
  line-height: initial;
  border-radius: 0;
  background-color: $midnight-blue;
  opacity: .5;
  border-color: $midnight-blue;
  transition: .3s ease;

  @media (max-width: 42rem) {
    top: 50%;
  }

  &:hover {
    opacity: 1;
  }

  &.prev {
    left: 0;
  }
  &.next {
    right: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/funding/FundingCarousel.vue